import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import { savingsFollowupReportGet } from './savings-followup.service';
import AlertManager from '../../../utils/alertManager';
import {
	getSavingsFollowupReportFailure,
	getSavingsFollowupReportResponseChanged,
	getSavingsFollowupReportSuccess,
} from './savings-followup.action';
import SavingsFollowupReportActionTypes from './savings-followup.types';

/** ********************* START GET SAVINGS FOLLOWUP REPORT DETAILS ******************** */

export function* getSavingsFollowupReport({ payload }: any) {
	try {
		const key = 'GetSavingsFollowUpReportKey'; // Use appropriate encryption key
		const {
			companyID,
			branchID,
			databaseName,
			requestStartDate,
			requestEndDate,
			year,
			groupID,
			viewBy,
			month,
			memberID,
			centerID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: requestStartDate,
			ToDate: requestEndDate,
			Branch: branchID,
			CenterID: centerID,
			GroupID: groupID,
			MemberID: memberID,
			Month: month,
			ViewBy: viewBy,
			Year: year,
			companyID: companyID,
			SearchType: 'Date',
		};
		const encodeData = encryptData(jsonData, key);

		// @ts-ignore
		const responseData = yield call(savingsFollowupReportGet, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSavingsFollowupReportFailure(responseData.data));
		} else {
			yield put(getSavingsFollowupReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSavingsFollowupReportFailure(error));
	}
}

export function* resetGetSavingsFollowupReportResponse() {
	yield put(getSavingsFollowupReportResponseChanged());
}

export function* onGetSavingsFollowupReport() {
	yield takeLatest(
		SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_START,
		getSavingsFollowupReport,
	);
}

export function* onGetSavingsFollowupReportResponseReset() {
	yield takeLatest(
		SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_RESPONSE_RESET,
		resetGetSavingsFollowupReportResponse,
	);
}

/** ********************* END GET SAVINGS FOLLOWUP REPORT DETAILS ******************** */

// Export all sagas for root saga
export function* savingsFollowupReportSaga() {
	yield all([call(onGetSavingsFollowupReport), call(onGetSavingsFollowupReportResponseReset)]);
}
